import { Badge } from "@mantine/core"
import { PackageIcon, TruckIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"

/** Priority of a delivery note's SLA as a localized badge (VIP, urgent, high); other values show nothing. */
export function PriorityBadge({ priority }: Readonly<{ priority?: string | null }>) {
  const { t } = useTranslation(["delivery"])
  if (priority === "VIP") return <Badge size="lg" color="red" variant="light" radius="sm" tt="none">{t("delivery:route.wizardUi.priority.VIP")}</Badge>
  if (priority === "URGENT") return <Badge size="lg" color="orange" variant="light" radius="sm" tt="none">{t("delivery:route.wizardUi.priority.URGENT")}</Badge>
  if (priority === "HIGH") return <Badge size="lg" color="yellow" variant="light" radius="sm" tt="none">{t("delivery:route.wizardUi.priority.HIGH")}</Badge>
  return null
}

/** Delivery channel (local delivery / supply freight) as a localized badge; an unknown channel shows nothing. */
export function ChannelBadge({ channel }: Readonly<{ channel?: string | null }>) {
  const { t } = useTranslation(["delivery"])
  if (channel === "LOCAL_DELIVERY")
    return (
      <Badge size="lg" color="green" variant="light" radius="sm" tt="none" leftSection={<TruckIcon size={16} weight="fill" />}>
        {t("delivery:route.wizardUi.channel.LOCAL_DELIVERY")}
      </Badge>
    )
  if (channel === "SUPPLY_FREIGHT")
    return (
      <Badge size="lg" color="orange" variant="light" radius="sm" tt="none" leftSection={<PackageIcon size={16} weight="fill" />}>
        {t("delivery:route.wizardUi.channel.SUPPLY_FREIGHT")}
      </Badge>
    )
  return null
}
